'use client';

import { cn } from '@/lib/utils';
import { prepareRichTextHtml } from '@/lib/rich-text';

export const richTextProseClass =
  'rich-text [&_ul]:list-disc [&_ul]:ml-5 [&_ol]:list-decimal [&_ol]:ml-5 [&_li]:mb-1 [&_a]:text-primary [&_a]:underline [&_strong]:font-bold [&_em]:italic [&_u]:underline';

/** Default body copy — matches service/career detail pages. */
export const richTextBodyClass = 'rich-text-body font-sans';

/** Long-form article body — matches insight detail page. */
export const richTextArticleClass = 'rich-text-article font-sans';

interface RichTextProps {
  html: string;
  className?: string;
  as?: 'div' | 'p' | 'span' | 'h1' | 'h2' | 'h3';
}

export function RichText({ html, className, as: Tag = 'div' }: RichTextProps) {
  const prepared = prepareRichTextHtml(html);
  if (!prepared) return null;
  return (
    <Tag
      className={cn(richTextProseClass, className)}
      dangerouslySetInnerHTML={{ __html: prepared }}
    />
  );
}
